import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { CampaignsService } from "src/app/pages/campaign-module/campaigns/campaigns.service";
import { DistributionPromoDetail } from "src/app/model/distribution-promo-detail";
import * as _ from "lodash";
import { DistributionPromoMechanic } from "src/app/model/distribution-promo-mechanic";
import * as moment from "moment";
import { DistributionPromoDetailSku } from "src/app/model/distribution-promo-sku";
import { DialogService } from "src/app/services/dialog/dialog.service";
import { LanguageService } from "src/app/services/language/language.service";
import { MatAutocomplete } from "@angular/material/autocomplete";
import { Category } from "src/app/model/category";
import { Sku } from "src/app/model/sku";
import { Brand } from "src/app/model/brand";

@Component({
  selector: "esc-copier",
  templateUrl: "./copier.component.html",
  styleUrls: ["./copier.component.scss"]
})
export class CopierComponent implements OnInit {
  @Input("currentStep") currentStep;
  @Input("originals") originals;
  @Output() copySelected = new EventEmitter();
  @Input() distribution;
  @ViewChild("duplicateAC") duplicateAC: MatAutocomplete;
  form: FormGroup;

  loading = {
    duplicate: false,
    merging: false
  };
  public listData: DistributionPromoDetail[] = [];

  constructor(
    private fb: FormBuilder,
    private campaignService: CampaignsService,
    private dialogService: DialogService,
    private languageService: LanguageService
  ) {}

  ngOnInit() {
    this.initForm();
    this.detectFormChanges();
  }

  initForm() {
    this.form = this.fb.group({
      duplicate: null
    });
  }

  detectFormChanges() {
    this.form.get("duplicate").valueChanges.subscribe(value => {
      this.loading.duplicate = true;
      this.getListData(null, 0, 0, this.distribution["campaign_id"], value);
    });
  }

  getInitialValues(data) {
    if (data) {
      this.getListData(data, 0, 0, this.distribution["campaign_id"], "");
    }
  }

  ngOnChanges(changes: SimpleChanges) {}

  getListData(data?, distribution_id?: number, distribution_promo_detail_ids?: number, distribution?: number, key?: string) {
    this.loading.duplicate = true;
    this.campaignService.getDistributionPromoDetailList(distribution_id, distribution_promo_detail_ids, distribution, key).subscribe(result => {
      this.loading.duplicate = false;
      this.listData = [];
      if (result.value == "Success") {
        for (let detail of result.data) this.listData = this.listData.concat(detail);
      }
    });
  }

  autoCmpltClosed() {
    if (this.form.get("duplicate").value) {
      this.loading.merging = true;
      this.getDetailMechanicsAndSkus();
      this.listData = [];
    }
  }

  getDetailMechanicsAndSkus() {
    let dis_id = this.form.get("duplicate").value.id;
    let promoDetails = new DistributionPromoDetail();
    this.campaignService.getDistributionPromoDetailMechanicList(0, dis_id).subscribe(result => {
      if (result.value == "Success" || result.value == "Empty Object") {
        promoDetails._id = this.form.get("duplicate").value.id;
        promoDetails._distribution_promo_id = this.form.get("duplicate").value.distribution_promo_id;
        promoDetails._description = this.form.get("duplicate").value.description;
        promoDetails._priority = this.form.get("duplicate").value.priority;
        promoDetails._start_date = moment(this.form.get("duplicate").value.start_date).format("YYYY-MM-DD");
        promoDetails._end_date = moment(this.form.get("duplicate").value.end_date).format("YYYY-MM-DD");
        promoDetails._capacity = this.form.get("duplicate").value.capacity;
        promoDetails._capacity_reset_period = this.form.get("duplicate").value.capacity_reset_period;
        promoDetails._capacity_reset_period_qty = this.form.get("duplicate").value.capacity_reset_period_qty;
        promoDetails._capacity_reset_day = this.form.get("duplicate").value.capacity_reset_day;
        promoDetails._mechanic_period = this.form.get("duplicate").value.mechanic_period;
        promoDetails._apply_for_every_nth_pcs = this.form.get("duplicate").value.apply_for_every_nth_pcs;
        promoDetails._apply_discount_to = this.form.get("duplicate").value.apply_discount_to;
        promoDetails._is_distribution_date = this.form.get("duplicate").value.is_distribution_date;
        promoDetails._distribution_promo_mechanic = [];
        for (let index in result.data) {
          let mechanic = new DistributionPromoMechanic();
          let mechaData = result.data[index];
          mechanic._id = mechaData["id"];
          mechanic._sequence = mechaData["sequence"];
          mechanic._mechanic_period_from_qty = mechaData["mechanic_period_from_qty"];
          mechanic._mechanic_period_to_qty = mechaData["mechanic_period_to_qty"];
          mechanic._purchase_min = mechaData["purchase_min"];
          mechanic._purchase_max = mechaData["purchase_max"];
          mechanic._discount_value = mechaData["discount_value"];

          promoDetails._distribution_promo_mechanic = promoDetails._distribution_promo_mechanic.concat(mechanic);
        }

        this.campaignService.getDistributionPromoDetailSKUList(0, promoDetails._id).subscribe(result => {
          console.log(result);
          if (result.value == "Success" || result.value == "Empty Object") {
            promoDetails._distribution_promo_sku = [];
            for (let index in result.data) {
              if (result.data[index]["mode"] == "Sku") {
                let newSku = new Sku();
                newSku._id = result.data[index]["sku"]["id"];
                newSku._description = result.data[index]["sku"]["description"];
                let sku: DistributionPromoDetailSku = new DistributionPromoDetailSku(
                  result.data[index]["id"],
                  result.data[index]["distribution_promo_detail_id"],
                  null,
                  null,
                  newSku
                );
                promoDetails._distribution_promo_sku = promoDetails._distribution_promo_sku.concat(sku);
              }
              if (result.data[index]["mode"] == "Brand") {
                let newBrand = new Brand();
                newBrand._id = result.data[index]["brand"]["id"];
                newBrand._description = result.data[index]["brand"]["description"];

                let sku: DistributionPromoDetailSku = new DistributionPromoDetailSku(
                  result.data[index]["id"],
                  result.data[index]["distribution_promo_detail_id"],
                  null,
                  newBrand,
                  null
                );
                promoDetails._distribution_promo_sku = promoDetails._distribution_promo_sku.concat(sku);
              }
              if (result.data[index]["mode"] == "Category") {
                // console.log(result.data[index]["category"]["description"]);
                let newCat = new Category();
                newCat._id = result.data[index]["category"]["id"];
                newCat._description = result.data[index]["category"]["description"];

                let sku: DistributionPromoDetailSku = new DistributionPromoDetailSku(
                  result.data[index]["id"],
                  result.data[index]["distribution_promo_detail_id"],
                  newCat,
                  null,
                  null
                );
                promoDetails._distribution_promo_sku = promoDetails._distribution_promo_sku.concat(sku);
              }
            }

            this.copySelected.next(promoDetails);
          } else {
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          }

          this.loading.merging = false;
        });
      } else {
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
      }
    });
  }

  displayFn(data?: any): string | undefined {
    if(data) {
      return (_.get(data, 'code') ? (_.get(data, 'code') + ' - ') : "")  + _.get(data, 'description');
    }
    return null;
  }

  clearForm(ev: Event) {
    this.form.get('duplicate').setValue(null, { emitEvent: false });
    this.copySelected.next(null);
    // ev.stopPropagation();
  }
}
